import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SEOMeta(props) {
  const { t } = useTranslation();
  const location = useLocation();

  const jsonLd = {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: t("seo.orgName"),
    url: "https://riv-tech.co.kr",
    // address: {
    //   "@type": "PostalAddress",
    //   postalCode: "14055",
    //   addressRegion: "경기도",
    //   addressLocality: "안양시 동안구",
    //   streetAddress: "시민대로327번길 11-41",
    // },
    sameAs: [
      "https://blog.naver.com/rivsw",
      "https://www.instagram.com/rivtechnology/",
      "https://www.facebook.com/profile.php?id=61563844645879",
    ],
  };

  React.useEffect(() => {
    document.title = props.title;
  }, [location, props.title]);
  return (
    <Helmet key={props.pathname}>
      <title>{props.title}</title>
      <meta
        name="description"
        content={props.description}
      />
      <meta
        name="keywords"
        content={props.keywords}
      />
      {/* Open Graph, Twitter Card */}
      <meta
        property="og:title"
        content={props.title}
      />
      <meta
        property="og:description"
        content={props.description}
      />
      {/* <meta property="og:image" content={props.image} /> */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </Helmet>
  );
}

export default SEOMeta;
